/**
 * Required by the fatsecret Platform API Attribution Policy wherever its data
 * is shown. The snippet's HTML must not be modified, so only the wrapper is styled.
 */
export function FatSecretAttribution() {
  return (
    <div className="tiny muted" style={{ textAlign: 'center', padding: '8px 0' }}>
      <a href="https://platform.fatsecret.com">Powered by fatsecret Platform API</a>
    </div>
  );
}
